const lbaTagSelect = angular.module('app.lbaTagSelect', []);

lbaTagSelect.controller('lbaTagSelectCtrl', require('./lbaTagSelectCtrl'));
lbaTagSelect.directive('lbaTagSelect', require('./lbaTagSelectDir'));

export default lbaTagSelect;



// WEBPACK FOOTER //
// ./src/components/lbaTagSelect/index.js